import { alphabets } from "~/utils/helpers";

const GlossaryAlphabetMenu = () => {
	return (
		<div className="sticky top-28 hidden w-full flex-col gap-4 lg:flex">
			<h4 className="font-semibold text-2xl">Sort by Alphabet:</h4>
			<div className="flex flex-wrap gap-3">
				{alphabets.map((alphabet) => (
					<a
						className="flex h-10 w-10 items-center justify-center rounded-lg bg-slate-50 text-xl hover:bg-slate-100 dark:bg-slate-700 dark:hover:bg-slate-600"
						href={`#${alphabet.toUpperCase()}`}
						key={alphabet}
					>
						{alphabet.toUpperCase()}
					</a>
				))}
			</div>
		</div>
	);
};

export default GlossaryAlphabetMenu;
